import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback } from "reactstrap";
import Select from "react-select";

import { getThematicAreas } from "common/services/data-types.service";
import { normalize } from "common/lib/normalize";

const SelectThematicArea = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.thematicArea && validation.errors.thematicArea
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.thematicArea && validation.errors.thematicArea
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getThematicAreas({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const options = useMemo(() => {
    const mainOptions = data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });

    mainOptions.unshift({ value: null, label: "None" });
    return mainOptions;
  }, [data]);

  return (
    <>
      <Label htmlFor="thematicArea-field" className="form-label">
        Thematic Area
      </Label>
      <Select
        name="thematicArea"
        id="thematicArea"
        value={
          validation.values.thematicArea.value
            ? validation.values.thematicArea
            : null
        }
        placeholder="Select thematic area"
        onChange={(value: any) => {
          validation.setFieldValue("thematicArea", value);
          validation.setFieldError("thematicArea", "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("thematicArea", true)}
        className={
          validation.touched.thematicArea && validation.errors.thematicArea
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        loading={loading}
      />
      <FormFeedback>{validation.errors.thematicArea?.value}</FormFeedback>
    </>
  );
};

export default SelectThematicArea;
